import { Trans } from '@lingui/react'
import { bool, number, oneOfType, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import './InputToBeCopied.scss'

export const INPUT_ID_DESKTOP = 'InputToBeCopied__input'
export const INPUT_ID_MOBILE = 'InputToBeCopied__input-mobile'

const InputToBeCopied = ({
  name,
  value,
  className,
  inputId,
  buttonText,
  textCopied,
  useButton,
}) => {
  const ButtonComponent = useButton ? Button : ButtonAsLink
  const TextCopied = textCopied || <Trans id="socialModal.label.linkCopied" />

  return (
    <div
      className={`m-InputToBeCopied ${className}`}
      data-clientside-hook="copyField"
    >
      <div className="a-box a-box--white a-box--bordered u-margin--bottom">
        <span
          className="u-color--grey a-truncate-with-ellipsis u-display--block"
          data-clientside-hook="copyField__text"
        >
          {value}
        </span>
        <span
          className="u-color--positive"
          aria-hidden="true"
          data-clientside-hook="copyField__success"
        >
          {TextCopied}
        </span>
        <label htmlFor="InputToBeCopied__input">
          <input
            id={inputId}
            className="m-InputToBeCopied__input"
            name={name}
            value={value}
            readOnly
            data-clientside-hook="copyField__value"
          />
        </label>
      </div>
      <div className="u-font-weight--bold">
        <ButtonComponent
          name="inputToBeCopied__button"
          isClientsideControlled
          data-clientside-hook="copyField__button"
        >
          {buttonText}
        </ButtonComponent>
      </div>
    </div>
  )
}

InputToBeCopied.propTypes = {
  name: string,
  value: oneOfType([string, number, bool]).isRequired,
  className: string,
  inputId: string,
  useButton: bool,
  buttonText: string.isRequired,
  textCopied: string,
}

InputToBeCopied.defaultProps = {
  name: 'inputToBeCopied',
  className: '',
  inputId: 'InputToBeCopied__input',
  useButton: false,
  textCopied: null,
}

export default InputToBeCopied
